import { AppAreaConfig } from '@/funnels/@types'

type FunnelGroup = {
	id: string
	name: string
	appAreas: AppAreaConfig[]
}

export const FUNNEL_GROUPS: FunnelGroup[] = [
	{
		id: 'fasting',
		name: 'Fasting',
		appAreas: [
			require('./areas/fasting/female').default,
			require('./areas/fasting/male').default,
			require('./areas/fasting/main').default,
		],
	},
	{
		id: 'yoga',
		name: 'Yoga',
		appAreas: [
			require('./areas/yoga/activity-female-yoga').default,
			require('./areas/yoga/activity-male-chair-workouts').default,
			require('./areas/yoga/main-yoga').default,
		],
	},
	{
		id: 'walking',
		name: 'Walking',
		appAreas: [
			require('./areas/walking/activity-female-walking').default,
			require('./areas/walking/activity-male-walking').default,
			require('./areas/walking/female-printable-walking').default,
			require('./areas/walking/main-walking').default,
		],
	},
	{
		id: 'pilates',
		name: 'Pilates',
		appAreas: [
			require('./areas/pilates/activity-female-pilates').default,
			require('./areas/pilates/activity-female-senior-pilates').default,
			require('./areas/pilates/activity-female-boudoir-pilates-fwf').default,
		],
	},
	{
		id: 'activity',
		name: 'Activity',
		appAreas: [
			require('./areas/activity/activity-female-v2').default,
			require('./areas/activity/activity-male').default,
			require('./areas/activity/main-activity').default,
		],
	},
	{
		id: 'tai-chi',
		name: 'Tai Chi',
		appAreas: [
			require('./areas/tai-chi/activity-female-tai-chi').default,
			require('./areas/tai-chi/activity-female-tai-chi-walking').default,
			require('./areas/tai-chi/activity-female-tai-chi-walking-v2').default,
			require('./areas/tai-chi/activity-female-tai-chi-walking-pr').default,
			require('./areas/tai-chi/activity-male-tai-chi-walking').default,
			require('./areas/tai-chi/activity-male-tai-chi-yoga').default,
			require('./areas/tai-chi/main-tai-chi').default,
			require('./areas/tai-chi/main-tai-chi-walking').default,
		],
	},
	{
		id: 'glp',
		name: 'GLP',
		appAreas: [require('./areas/glp/female-glp').default],
	},
	{
		id: 'calisthenics',
		name: 'Calisthenics',
		appAreas: [
			require('./areas/calisthenics/activity-female-calisthenics').default,
			require('./areas/calisthenics/activity-male-calisthenics').default,
			require('./areas/calisthenics/main-calisthenics').default,
		],
	},
	{
		id: 'japanese-walking',
		name: 'Japanese Walking',
		appAreas: [
			require('./areas/japanese-walking/activity-female-walking-japanese').default,
			require('./areas/japanese-walking/activity-female-walking-japanese-v2').default,
		],
	},
	{
		id: 'asian-pilates',
		name: 'Asian Pilates',
		appAreas: [require('./areas/asian-pilates/activity-female-asian-pilates').default],
	},
	{
		id: 'military',
		name: 'Military',
		appAreas: [require('./areas/military/military-male').default],
	},
	{
		id: 'water-fasting',
		name: 'Water Fasting',
		appAreas: [require('./areas/water-fasting/female-water-balance').default],
	},
	{
		id: 'high-protein',
		name: 'High Protein',
		appAreas: [require('./areas/high-protein/female-high-protein').default],
	},
	{
		id: 'diets',
		name: 'Diets',
		appAreas: [
			require('./areas/diets/female-cortisol-diet').default,
			require('./areas/diets/female-menopause-diet').default,
			require('./areas/diets/female-mediterranean-diet').default,
			require('./areas/diets/female-anti-inflammatory-diet').default,
		],
	},
	{
		id: 'applovin',
		name: 'AppLovin',
		appAreas: [
			require('./areas/applovin/activity-female-pilates-al').default,
			require('./areas/applovin/activity-female-walking-al').default,
			require('./areas/applovin/activity-female-yoga-al').default,
			require('./areas/applovin/female-al').default,
			require('./areas/applovin/activity-female-tai-chi-walking-al').default,
			require('./areas/applovin/activity-female-tai-chi-walking-v2-al').default,
		],
	},
	{
		id: 'other',
		name: 'Other',
		appAreas: [
			require('./areas/other/assessment').default,
			require('./areas/other/together').default,
			require('./areas/other/workbooks').default,
		],
	},
]

export const APP_AREAS: AppAreaConfig[] = FUNNEL_GROUPS.flatMap((group) => group.appAreas)
